import React from "react"
import { motion } from "framer-motion"
import target from '../../../assets/images/target.png'
const sectionReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: "easeOut" },
  viewport: { once: true, amount: 0.2 },
}

// Hover offset for cards
const hoverShift = (idx = 0) => {
  const mod = idx % 3
  if (mod === 0) return { x: -6, y: -4 }
  if (mod === 1) return { x: 0, y: -6 }
  return { x: 6, y: -4 }
}

// Cards container (stagger cards)
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.3,
    },
  },
}

// Card animation (slide from left)
const cardVariants = {
  hidden: { opacity: 0, x: -60 },
  show: {
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 120, damping: 20 },
  },
}

// Inner content container (stagger icon → title → text)
const contentVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
}

// Inner content animation
const contentItem = {
  hidden: { opacity: 0, y: 14 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: "easeOut" },
  },
}

export default function Vision() {
  return (
    <motion.section {...sectionReveal} className="mt-16 px-4 sm:px-8 pb-16">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        {/* <div className="text-center mb-12">
          <p className="text-4xl font-semibold text-sky-700">رسالتنا ورؤيتنا</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">
            الهدف العام - الرؤية - الرسالة
          </h2>
        </div> */}

        {/* Cards */}
        <motion.div
          className="grid gap-6 lg:grid-cols-3"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >

          {/* CARD 1 */}
          <motion.div
            variants={cardVariants}
            whileHover={{ scale: 1.03, ...hoverShift(0) }}
            className="relative overflow-hidden rounded-[32px] bg-white/95 border border-sky-100 shadow-[0_25px_60px_-20px_rgba(15,23,42,0.35)] backdrop-blur-sm"
          >
            <div className="absolute -left-12 -top-16 h-32 w-32 rounded-full bg-sky-200/30 blur-3xl" />
            <div className="absolute inset-0 bg-gradient-to-b from-sky-50/70 via-white/80 to-white" />

            <motion.div
              className="relative p-8 flex flex-col gap-4"
              variants={contentVariants}
            >
              <motion.div
                variants={contentItem}
                className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#28A2BD] to-sky-700 text-white shadow-lg ring-4 ring-white/60"
              >
                {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <circle cx="12" cy="12" r="8" />
                  <circle cx="12" cy="12" r="4" />
                  <path d="M12 3v2" strokeLinecap="round" />
                  <path d="M12 19v2" strokeLinecap="round" />
                  <path d="M3 12h2" strokeLinecap="round" />
                  <path d="M19 12h2" strokeLinecap="round" />
                </svg> */}
                <img src={target} alt="target" className="h-8 w-8" />
              </motion.div>

              <motion.h3
                variants={contentItem}
                className="text-center text-2xl font-extrabold tracking-wide text-[#28A2BD]"
              >
                الهدف العام
              </motion.h3>

              <motion.p
                variants={contentItem}
                className="text-lg leading-relaxed text-slate-700 text-center"
              >
                تنمية القدرات البشرية لمنسوبي الجامعة من خلال التدريب وتعزيز بناء الشراكات
                المحلية والدولية لدعم التحول والتطوير المهني والأكاديمي بالجامعة بما يسهم
                في خدمة المجتمع.
              </motion.p>
            </motion.div>
          </motion.div>

          {/* CARD 2 */}
          <motion.div
            variants={cardVariants}
            whileHover={{ scale: 1.03, ...hoverShift(1) }}
            className="relative overflow-hidden rounded-[32px] bg-white/95 border border-emerald-100 shadow-[0_25px_60px_-20px_rgba(15,23,42,0.35)] backdrop-blur-sm"
          >
            <div className="absolute -left-16 -top-10 h-32 w-32 rounded-full bg-emerald-200/25 blur-3xl" />
            <div className="absolute inset-0 bg-gradient-to-b from-emerald-50/70 via-white/80 to-white" />

            <motion.div className="relative p-8 flex flex-col gap-4" variants={contentVariants}>
              <motion.div
                variants={contentItem}
                className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#29A182] to-emerald-700 text-white shadow-lg ring-4 ring-white/60"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 5c-5 0-9 6.5-9 7s4 7 9 7 9-6.5 9-7-4-7-9-7Z" />
                  <circle cx="12" cy="12" r="3.5" />
                </svg>
              </motion.div>

              <motion.h3 variants={contentItem} className="text-center text-2xl font-extrabold tracking-wide text-[#29A182]">
                الرؤية
              </motion.h3>

              <motion.p variants={contentItem} className="text-lg leading-relaxed text-slate-700 text-center">
                الريادة في تطوير المهارات وتمكين رأس المال البشري عبر برامج تدريبية وشراكات نوعية.
              </motion.p>
            </motion.div>
          </motion.div>

          {/* CARD 3 */}
          <motion.div
            variants={cardVariants}
            whileHover={{ scale: 1.03, ...hoverShift(2) }}
            className="relative overflow-hidden rounded-[32px] bg-white/95 border border-indigo-100 shadow-[0_25px_60px_-20px_rgba(15,23,42,0.35)] backdrop-blur-sm"
          >
            <div className="absolute -left-12 -top-16 h-32 w-32 rounded-full bg-indigo-200/30 blur-3xl" />
            <div className="absolute inset-0 bg-gradient-to-b from-indigo-50/70 via-white/80 to-white" />

            <motion.div className="relative p-8 flex flex-col gap-4" variants={contentVariants}>
              <motion.div
                variants={contentItem}
                className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#486191] to-indigo-700 text-white shadow-lg ring-4 ring-white/60"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M4 17a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4" strokeLinecap="round" />
                  <circle cx="8" cy="9" r="3" />
                  <circle cx="16" cy="9" r="3" />
                </svg>
              </motion.div>

              <motion.h3 variants={contentItem} className="text-center text-2xl font-extrabold tracking-wide text-[#486191]">
                الرسالة
              </motion.h3>

              <motion.p variants={contentItem} className="text-lg leading-relaxed text-slate-700 text-center">
                الإسهام في تنمية قدرات منسوبي الجامعة لتمكينهم من المساهمة الفاعلة في خدمة المجتمع.
              </motion.p>
            </motion.div>
          </motion.div>

        </motion.div>
      </div>
    </motion.section>
  )
}
